/** @module Export/ImportCoverageStores */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/comm/GetRequest",
	"csi/locale",
	"csi/reflection",
	"csi/store/_ClientRequestMixin",
	"csi/store/Nodes",
	"csi/xml"
], function(declare, csi, _, GetRequest, locale, reflection, _ClientRequestMixin, Nodes, xml) {

	/**
	 * @param {Node[]} data
	 * @param {Deferred} dfd
	 */
	var _fillResults = function(data, dfd) {
		csi.forEachWithTimeout(
			data,
			10,
			null,
			null,
			function() {
				_.each(data, function(node) {
					xml.nodeCreateClientAttr(node, "ExportClassLocalized", xml.ATTR_STRING, locale.type(node.$Name));
				});

				// store is ready, so return
				dfd.resolve(data);
			}
		);
	};

	var _InStore = declare([Nodes, _ClientRequestMixin], {
		bSimpleQueryEngine: true,

		_resolveData: function(dfd) {
			new GetRequest("Export", "GetImporterSupportedNodeTypes", {
			}).go().then(function(res) {
				var data = csi.transform(res.getReturnValue(), function(type) {
					var rc = reflection.getClass(type);

					if (rc) {
						var node = xml.nodeCreateClientNode(rc.getURL(), reflection.TYPE_BUSINESS_OBJECT, type);
						return node;
					}
					return null;
				}, this);

				_fillResults(data, dfd);
			}, this);
		}

	});

	var _inStore = new _InStore();

	return {
		In: _inStore
	};
});